import React, {useEffect, useState} from 'react';
import {Box, IconButton, Modal, Switch} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import classNames from "classnames";
import * as s from './styles.module.css';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '640px',
    width: '100%',
    maxHeight: '90dvh',
    overflowY: 'auto',
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 1)',
    padding: '32px',
    borderRadius: '30px',
    '@media (max-width: 1024px)': {
        borderRadius: '0px',
        border: 'none',
        height: '100dvh',
        maxHeight: '100dvh',
        width: '100vw',
        padding: '16px',
    },
};

const CATEGORY_COPY = [
    {
        key: 'necessary',
        title: 'Strictly necessary',
        text: 'Required for the site to work and to remember your cookie choice. Always on.',
        locked: true,
    },
    {
        key: 'functional',
        title: 'Functional',
        text: 'Booking and contact forms, the chat widget, Google Maps and the reviews widget. Off means these appear as a placeholder you can load with one click.',
    },
    {
        key: 'analytics',
        title: 'Analytics',
        text: 'Helps us understand which pages people visit so we can improve the site, and lets our advertising partners measure how well our campaigns work.',
    },
];

const PreferencesModal = ({open, consent, onClose, onSave, onAcceptAll, onRejectAll}) => {
    const [draft, setDraft] = useState(consent);

    useEffect(() => {
        if (open) setDraft(consent);
    }, [open, consent]);

    return (
        <Modal open={open} onClose={onClose} sx={{zIndex: 2100}} aria-labelledby="cookie-preferences-title">
            <Box sx={style}>
                <div className={'flex w-full items-start justify-between gap-[16px]'}>
                    <h3 id="cookie-preferences-title" className={s.modalTitle}>Cookie preferences</h3>
                    <IconButton onClick={onClose} sx={{width: '40px', height: '40px'}} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>
                </div>

                <p className={s.modalIntro}>
                    Choose which cookies we may use. Nothing outside “strictly necessary” loads until you allow
                    it, and you can change this at any time from the Cookie Settings link in the footer.
                </p>

                <div className={'mt-[16px]'}>
                    {CATEGORY_COPY.map((category) => (
                        <div key={category.key} className={s.category}>
                            <div>
                                <p className={s.categoryTitle}>{category.title}</p>
                                <p className={s.categoryText}>{category.text}</p>
                            </div>
                            <Switch
                                checked={category.locked ? true : Boolean(draft[category.key])}
                                disabled={category.locked}
                                inputProps={{'aria-label': category.title}}
                                onChange={(e) => setDraft((prev) => ({...prev, [category.key]: e.target.checked}))}
                            />
                        </div>
                    ))}
                </div>

                <div className={s.modalActions}>
                    <button type="button" className={classNames(s.btn, s.secondary)} onClick={onRejectAll}>
                        Reject all
                    </button>
                    <button type="button" className={classNames(s.btn, s.secondary)} onClick={() => onSave(draft)}>
                        Save choices
                    </button>
                    <button type="button" className={classNames(s.btn, s.primary)} onClick={onAcceptAll}>
                        Accept all
                    </button>
                </div>
            </Box>
        </Modal>
    );
};

export default PreferencesModal;
